// src/components/NotFound.js
import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
    return (
        <div className="error-page">
            <div className="error-code">404</div>
            <h1>Page Not Found</h1>
            <p>
                Sorry, the page you are looking for does not exist or has been moved.
            </p>
            <Link to="/" className="btn btn-primary">
                Back to Home
            </Link>
        </div>
    );
};

export default NotFound;